<template>
    <div>
        <topNav></topNav>
        <router-view></router-view>
        <bottomNav></bottomNav>
    </div>
</template>

<script>
    import topNav from './topNav'
    import bottomNav from './bottomNav'
    export default {
        name: "layout",
        components:{
            topNav,
            bottomNav
        }
    }
</script>

<style scoped>

</style>
